import { debounce } from '@/core/utils/lodash';

const onResizeDelay = 100;

type TopUIEvent = UIEvent & { topEvent: { widthDiff: number, hightDiff: number } }

/**
 * Установленные обрабочики на событие изменения размеров окна
 */
const onResizeListeners: Map<(e: TopUIEvent) => any, (e: TopUIEvent) => any> = new Map();

// зафиксированное состояние размеров окна
const windowSize = {
	width: window.innerWidth,
	height: window.innerHeight,
};

/**
 * Добавить обработчик на событие изменения размеров экрана
 * вызов таких обработчиков будет опмизирован и объединен в одно событие
 */
export const addOnReize = (listener: (this: HTMLElement, e: TopUIEvent) => void) => {
	onResizeListeners.set(listener, listener);
};

/**
 * Удаление обработчика на событие изменений размеров экрана
 */
export const removeOnResize = (listener: (this: HTMLElement, e: TopUIEvent) => void) => {
	onResizeListeners.delete(listener);
};

const onResize = debounce((e: UIEvent) => {
	const topUIEvent = e as TopUIEvent;

	topUIEvent.topEvent = {
		widthDiff: windowSize.width - window.innerWidth,
		hightDiff: windowSize.height - window.innerHeight,
	};

	windowSize.width = window.innerWidth;
	windowSize.height = window.innerHeight;

	onResizeListeners.forEach((callback) => callback(topUIEvent));
}, onResizeDelay);

window.addEventListener('resize', onResize);
